<template>
  <b-overlay :show="loading">
    <div>
      <div class="d-flex justify-content-between align-items-center mt-1 mb-0">
        <h1>CSV UPLOAD IMPORT REPORT</h1>
        <div class="d-flex align-items-center gap-1" style="gap: 5px;">
          <!-- <b-button variant="danger" @click="purgeReport">Purge</b-button> -->
          <b-button @click="rerunReport">Rerun</b-button>
        </div>
      </div>
      <ImportReport v-if="csvImportData && csvImportData.report" :import-report="csvImportData.report" />
    </div>

    <div v-if="report && reportErrors" class="my-3">
      <h1>Errors</h1>
      <b-table
        ref="errorsTable"
        class="position-relative"
        :items="reportErrors"
        :fields="errorsTableColumns"
        responsive
        show-empty
        primary-key="id"
        empty-text="No errors"
        :tbody-tr-class="''"
      >
      </b-table>
    </div>

    <div v-if="csvImportData" class="mt-2">
      <h1>Data Preview</h1>
      <b-table
        ref="refDataTable"
        class="position-relative"
        :items="csvImportData.content"
        :fields="getTableColumnsForContent(csvImportData.content || [])"
        responsive
        show-empty
        primary-key="id"
        empty-text="No matching records found"
        :tbody-tr-class="''"
      >
      <template #cell(stations_served)="data">
        <div v-b-tooltip.hover :title="data.item['Stations Served']" class="text-ellipsis">
          {{ truncate(data.item["Stations Served"], { length: 40 }) }}
        </div>
      </template>
      <template #cell(QUALIFICATIONS)="data">
        <div v-b-tooltip.hover :title="data.item['QUALIFICATIONS']" class="text-ellipsis">
          {{ truncate(data.item["QUALIFICATIONS"], { length: 40 }) }}
        </div>
      </template>
      <template #cell(wife_qualification)="data">
        <div v-b-tooltip.hover :title="data.item['WIFE QUALIFICATION']" class="text-ellipsis">
          {{ truncate(data.item["WIFE QUALIFICATION"], { length: 40 }) }}
        </div>
      </template>
      </b-table>
    </div>
  </b-overlay>
</template>

<script>
import {
  BMedia, BAvatar, BButton, VBTooltip,
  BOverlay, BCard, BRow, BCol, BAlert, BLink, BTable,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { get, startCase, truncate } from "lodash"

import ImportReport from '@/@core/components/import-report/ImportReport.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BOverlay,
    BCard,
    BTable,
    BRow,
    BCol,
    BAlert,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,
    ImportReport,

    vSelect,
  },
  data(){
    return {
      loading: false,
      csvImportData: null,
      errorsTableColumns: [
        { key: 'row', label: 'Row', formatter: (val) => `Row: #${val}`, sortable: true },
        { key: 'error', label: 'Error', sortable: true },
      ]
    }
  },
  computed: {
    report() {
      return this.csvImportData ? this.csvImportData.report : null
    },
    reportErrors() {
      return this.report ? this.report.errors : []
    },
  },
  created(){
    this.fetchPageData();
  },
  methods: {
    async fetchPageData() {
      try {
        this.loading = true; 
        const { id } = this.$route.params

        const request = await this.useJwt().mainService.csvImports.fetch(id);
        this.csvImportData = this.getValueFromSource(request, "data.data")
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async rerunReport() {
      try {
        this.loading = true; 
        const { id } = this.$route.params

        const request = await this.useJwt().mainService.csvImports.rerun(id);
        console.log(this.getValueFromSource(request, "data.data"))
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: "Rerun complete!"
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async purgeReport() {
      try {
        this.loading = true; 
        const { id } = this.$route.params

        const request = await this.useJwt().mainService.csvImports.purge(id);
        console.log(this.getValueFromSource(request, "data.data"))
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: "Purged!"
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    getTableColumnsForContent(contents) {
      const tableColumns = {}
      contents.forEach((content) => {
        const keys = Object.keys(content)
        keys.forEach((key) => {
          if (!tableColumns[key]) {
            tableColumns[key] = {
              label: startCase(key),
              key: this.getKey(key),
            }
          }
        })
      })
      console.log("Object.values(tableColumns)", Object.values(tableColumns))
      return Object.values(tableColumns)
    },
    getKey(key) {
      switch (key) {
        case 'Stations Served':
          return 'stations_served'
        case 'WIFE QUALIFICATION':
          return 'wife_qualification'
        default:
          return key
      }
    },
    truncate
  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-select.scss';
  .width-100 {
    width: 100px;
  }
  .per-page-selector {
    width: 90px;
  }
</style>



